import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LanguageContext } from "../container/language";

const PageContext = React.createContext({});

export const PageContextProvider = ({ pageContext, children }) => {
  const [articleType, setArticleType] = useState("INDIVIDUAL");
  const { changeUserLanguage, changeArticleType } = React.useContext(
    LanguageContext
  );
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(pageContext.lang);
    changeUserLanguage(pageContext.lang);
    if (pageContext.articleType) setArticleType(pageContext.articleType);
  }, [pageContext.lang, pageContext.articleType]);

  return (
    <PageContext.Provider
      value={{
        ...pageContext,
        articleType,
        changeArticleType: (selected) => {
          setArticleType(selected);
        },
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const usePageContext = () => React.useContext(PageContext);
